<template lang="pug">
    nav.headerNavbar.hidden-sm-and-down(:class="{'navigationAdmin': isAdmin}" aria-label="Main menu")
        router-link.navItem(
            v-for="(item, key) in items"
            :key="item.title"
            :to="item.link"
            :class="{isActive: checkPath(item.link)}"
        )
            img.mb-2(v-if="item.iconLink && isMember" :src="item.iconLink" :alt="item.iconAlt")
            v-icon.nav-icon(v-if="item.icon && isMember") {{ item.icon }}
            div.menuTitle(v-t="item.title")
</template>

<script>
    import VueTypes from 'vue-types';
    import { mapGetters } from 'vuex';

    export default {
        props: {
            items: VueTypes.array.def(),
            currentRoute: VueTypes.string.def('')
        },
        computed: {
            ...mapGetters('auth', ['isMember', 'isAdmin'])
        },
        methods: {
            checkPath(path) {
                return (
                    path === '/themes' &&
                    this.currentRoute.includes('/sessions')
                );
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../assets/style/_mixins.styl"
    @import "../../assets/style/_variables.styl";

    .headerNavbar
        display: flex
        align-items: center

        &.navigationAdmin
          a.navItem
            width: 80px
            margin-right: 0
            padding: 0 5px

          .menuTitle
            font-size: 14px

    a.navItem
        display: flex
        align-items: center
        justify-content: center
        flex-direction: column
        position: relative
        margin-right: 30px
        padding: 0 15px
        height: 85px
        width: 105px
        color: $theme.white
        text-decoration: none
        transition: color 0.3s
        white-space: nowrap

        img
            height: 16px

        .nav-icon
            color: $theme.white
            font-size: 20px
            margin-bottom: 3px

        &:last-child
            margin-right: 0

        &:hover
        &.router-link-active
        &.isActive
            color: $theme.action
            opacity: 1

            .nav-icon
                color: $theme.action
            img
                filter: invert(56%) sepia(51%) saturate(359%) hue-rotate(177deg) brightness(94%) contrast(94%);

        .menuTitle
            font-size: 15px
            font-weight: bold
            text-transform: capitalize
            text-align: center

      @media screen and (max-width: $grid-breakpoints.lg - 1)
          .headerNavbar
              &.navigationAdmin
                  a.navItem
                      width: auto
                      padding: 0 7px

                  .menuTitle
                      font-size: 13px
</style>
